// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResourceIdentifier
 */
export interface ResourceIdentifier {
  /**
   *
   */
  code: string;
  /**
   *
   */
  link?: string | null;
}

/**
 * Check if a given object implements the ResourceIdentifier interface.
 */
export function instanceOfResourceIdentifier(value: object): value is ResourceIdentifier {
  if (!("code" in value) || value["code"] === undefined) return false;
  return true;
}

export function ResourceIdentifierFromJSON(json: any): ResourceIdentifier {
  return ResourceIdentifierFromJSONTyped(json, false);
}

export function ResourceIdentifierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResourceIdentifier {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    link: json["link"] === undefined ? undefined : json["link"] === null ? null : json["link"],
  };
}

export function ResourceIdentifierToJSON(json: any): ResourceIdentifier {
  return ResourceIdentifierToJSONTyped(json, false);
}

export function ResourceIdentifierToJSONTyped(
  value?: ResourceIdentifier | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    link: value["link"],
  };
}
